/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface TableFilterCommands
 */
export interface TableFilterCommands {
    /**
     * 
     * @type {Command}
     * @memberof TableFilterCommands
     */
    applyCommand?: Command;
    /**
     * 
     * @type {Command}
     * @memberof TableFilterCommands
     */
    autoCompletionCommand?: Command;
    /**
     * 
     * @type {Command}
     * @memberof TableFilterCommands
     */
    resetCommand?: Command;
    /**
     * 
     * @type {Command}
     * @memberof TableFilterCommands
     */
    saveNewCommand?: Command;
}

/**
 * Check if a given object implements the TableFilterCommands interface.
 */
export function instanceOfTableFilterCommands(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TableFilterCommandsFromJSON(json: any): TableFilterCommands {
    return TableFilterCommandsFromJSONTyped(json, false);
}

export function TableFilterCommandsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableFilterCommands {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applyCommand': !exists(json, 'applyCommand') ? undefined : CommandFromJSON(json['applyCommand']),
        'autoCompletionCommand': !exists(json, 'autoCompletionCommand') ? undefined : CommandFromJSON(json['autoCompletionCommand']),
        'resetCommand': !exists(json, 'resetCommand') ? undefined : CommandFromJSON(json['resetCommand']),
        'saveNewCommand': !exists(json, 'saveNewCommand') ? undefined : CommandFromJSON(json['saveNewCommand']),
    };
}

export function TableFilterCommandsToJSON(value?: TableFilterCommands | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applyCommand': CommandToJSON(value.applyCommand),
        'autoCompletionCommand': CommandToJSON(value.autoCompletionCommand),
        'resetCommand': CommandToJSON(value.resetCommand),
        'saveNewCommand': CommandToJSON(value.saveNewCommand),
    };
}

